// Authentication configuration
export const AUTH_CONFIG = {
  // Allowed email domains for sign-in
  // You can set this via environment variable REACT_APP_ALLOWED_EMAIL_DOMAINS
  // or modify the default value below
  ALLOWED_EMAIL_DOMAINS: process.env.REACT_APP_ALLOWED_EMAIL_DOMAINS 
    ? process.env.REACT_APP_ALLOWED_EMAIL_DOMAINS.split(',').map(domain => domain.trim())
    : ['logic-joe.com'], // Replace with your actual company domain
  
  // Google OAuth configuration
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  
  // Error messages
  ERROR_MESSAGES: {
    DOMAIN_RESTRICTED: (domains: string[]) => 
      `Access denied. Only users from ${domains.join(', ')} are allowed to sign in.`,
    CLIENT_ID_MISSING: 'Google OAuth Client ID not configured. Please check the console for setup instructions.',
    GOOGLE_NOT_LOADED: 'Google Identity Services not loaded. Please refresh the page and try again.',
    INVALID_CLIENT: 'Invalid OAuth client. Please check your Google Cloud Console configuration.',
    NO_ACCESS_TOKEN: 'No access token received from Google',
  }
};
